import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=2578d611&scoped=true&"
import script from "./VideoModal.vue?vue&type=script&lang=js&"
export * from "./VideoModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=2578d611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578d611",
  null
  
)

export default component.exports